module.exports = __webpack_public_path__ + "media/images/language_switcher/gb-fd46970f89e3fbca473f57e811916ea0.svg";